// src/config.js
const config = {
  // API JSON + uploads are served from the Node host (admin domain returns SPA HTML for /apis/*).
  BASE_URL: "https://apis.starchakra.cloud/apis",
};

export default config;
